var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 21.0833C5.43121 21.0833 0.916748 16.5688 0.916748 11C0.916748 5.43109 5.43121 0.916626 11.0001 0.916626C16.569 0.916626 21.0834 5.43109 21.0834 11C21.0834 16.5688 16.569 21.0833 11.0001 21.0833ZM11.0001 19.25C15.5564 19.25 19.2501 15.5563 19.2501 11C19.2501 6.44361 15.5564 2.74996 11.0001 2.74996C6.44373 2.74996 2.75008 6.44361 2.75008 11C2.75008 15.5563 6.44373 19.25 11.0001 19.25ZM11.0001 4.58329V6.41663C13.5314 6.41663 15.5834 8.46865 15.5834 11H17.4167C17.4167 7.45613 14.5439 4.58329 11.0001 4.58329ZM11.0001 13.75C9.4813 13.75 8.25008 12.5187 8.25008 11C8.25008 9.48118 9.4813 8.24996 11.0001 8.24996C12.5189 8.24996 13.7501 9.48118 13.7501 11C13.7501 12.5187 12.5189 13.75 11.0001 13.75ZM11.9167 11C11.9167 11.5062 11.5063 11.9166 11.0001 11.9166C10.4938 11.9166 10.0834 11.5062 10.0834 11C10.0834 10.4937 10.4938 10.0833 11.0001 10.0833C11.5063 10.0833 11.9167 10.4937 11.9167 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/cd.c159d6560fbd9c33e3c1711458d6c0a2.svg";
export { ForwardRef as ReactComponent };